import {
  createDocument,
  updateDocument,
  deleteDocument,
  getDocument,
  getCollection,
} from "./FirebaseService";
import {
  getDocs,
  collection,
  query,
  orderBy,
  startAt,
  endAt,
  where,
  limit as limitFn,
} from "firebase/firestore";
import { db } from "../auth/firebase";

const COLLECTION = "courses";
const defaultAttendanceDetails = {
  Canberra: {
    group: "",
    trainer: "",
    room: "",
    block: "",
    term: "",
    day1: "",
    day2: "",
    day3: "",
    day4: "",
    day5: "",
  },
  Melbourne: {
    group: "",
    trainer: "",
    room: "",
    block: "",
    term: "",
    day1: "",
    day2: "",
    day3: "",
    day4: "",
    day5: "",
  },
};

const mapAttendanceDetails = (attendanceDetails = {}) => ({
  Canberra: {
    ...defaultAttendanceDetails.Canberra,
    ...(attendanceDetails.Canberra || {}),
  },
  Melbourne: {
    ...defaultAttendanceDetails.Melbourne,
    ...(attendanceDetails.Melbourne || {}),
  },
});

const mapToCourse = (data) => {
  const courseName = data.courseName || "";
  const courseCode = data.courseCode || "";

  return {
    courseName,
    courseCode,
    cricosCode: data.cricosCode || "",
    description: data.description || "",
    duration: Number(data.duration) || 0,

    fee: Number(data.fee) || 0,

    onshoreTuitionFee: data.onshoreTuitionFee || "",
    onshoreEnrolmentFee: data.onshoreEnrolmentFee || "",
    onshoreMaterialFee: data.onshoreMaterialFee || "",
    onshoreTotalFee: data.onshoreTotalFee || "",

    offshoreTuitionFee: data.offshoreTuitionFee || "",
    offshoreEnrolmentFee: data.offshoreEnrolmentFee || "",
    offshoreMaterialFee: data.offshoreMaterialFee || "",
    offshoreTotalFee: data.offshoreTotalFee || "",

    attendanceDetails: mapAttendanceDetails(data.attendanceDetails),

    instructor: data.instructor || "",
    capacity: Number(data.capacity) || 0,
    startDate: data.startDate || "",
    endDate: data.endDate || "",
    status: data.status || "active",
    requirements: data.requirements || "",
    notes: data.notes || "",

    courseName_lower: courseName.toLowerCase(),
    courseCode_lower: courseCode.toLowerCase(),

    createdAt: data.createdAt || new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };
};
// const mapToCourse = (data) => ({
//   courseName: data.courseName || "",
//   cricosCode: data.cricosCode || "",
//   courseCode: data.courseCode || "",
//   description: data.description || "",
//   duration: Number(data.duration) || 0,

//   fee: Number(data.fee) || 0,

//   onshoreTuitionFee: data.onshoreTuitionFee || "",
//   onshoreEnrolmentFee: data.onshoreEnrolmentFee || "",
//   onshoreMaterialFee: data.onshoreMaterialFee || "",
//   onshoreTotalFee: data.onshoreTotalFee || "",

//   offshoreTuitionFee: data.offshoreTuitionFee || "",
//   offshoreEnrolmentFee: data.offshoreEnrolmentFee || "",
//   offshoreMaterialFee: data.offshoreMaterialFee || "",
//   offshoreTotalFee: data.offshoreTotalFee || "",

//   instructor: data.instructor || "",
//   capacity: Number(data.capacity) || 0,
//   startDate: data.startDate || "",
//   endDate: data.endDate || "",
//   status: data.status || "active",
//   requirements: data.requirements || "",
//   notes: data.notes || "",
//   createdAt: data.createdAt || new Date().toISOString(),
//   updatedAt: new Date().toISOString(),
// });

// Create new course (optional custom ID)
export const createCourse = async (data, id) =>
  await createDocument(COLLECTION, mapToCourse(data), id);

// Update existing course
export const updateCourse = async (id, data) => {
  const existingCourse = await getDocument(COLLECTION, id);

  return await updateDocument(
    COLLECTION,
    id,
    mapToCourse({
      ...existingCourse,
      ...data,
      createdAt: existingCourse?.createdAt || data.createdAt,
    })
  );
};
// Delete course by ID
export const deleteCourse = async (id) => await deleteDocument(COLLECTION, id);

// Get a single course by ID
export const getCourse = async (id) => await getDocument(COLLECTION, id);

// Get all courses
export const getAllCourses = async () => await getCollection(COLLECTION);

export const searchCourse = async (searchText = "") => {
  const agentsRef = collection(db, COLLECTION);
  // No search -> return everything
  if (!searchText || !searchText.trim() || searchText === "") {
    const snapshot = await getDocs(agentsRef);
    return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  }

  const s = searchText.trim().toLowerCase();
  const end = s + "\uf8ff";

  try {
    const sampleSnap = await getDocs(
      query(agentsRef, orderBy("__name__"), limitFn(1))
    );
    const sampleDoc = sampleSnap.docs[0];
    const sampleData = sampleDoc ? sampleDoc.data() : null;

    const hasLowerFields =
      sampleData &&
      (Object.prototype.hasOwnProperty.call(sampleData, "courseCode_lower") ||
        Object.prototype.hasOwnProperty.call(sampleData, "courseName_lower"));

    if (hasLowerFields) {
      // run prefix queries in parallel on the lowercased fields
      const fieldsToQuery = ["courseCode_lower", "courseName_lower"];
      const queries = fieldsToQuery.map((field) =>
        query(agentsRef, orderBy(field), startAt(s), endAt(end))
      );

      const snaps = await Promise.all(
        queries.map((q) => getDocs(q).catch(() => ({ docs: [] })))
      );

      const results = [];
      snaps.forEach((snap) =>
        snap.docs.forEach((doc) => {
          results.push({ id: doc.id, ...doc.data() });
        })
      );

      // dedupe
      const unique = Object.values(
        results.reduce((acc, cur) => {
          acc[cur.id] = acc[cur.id] || cur;
          return acc;
        }, {})
      );

      return unique;
    } else {
      // FALLBACK: client-side filter (inefficient for large collections)
      const allSnap = await getDocs(agentsRef);
      const all = allSnap.docs.map((d) => ({ id: d.id, ...d.data() }));

      const filtered = all.filter((st) => {
        const fs = st.formState || st; // in your code agent data is nested in formState
        const courseCode = (fs.courseCode || "").toString().toLowerCase();
        const courseName = (fs.courseName || "").toLowerCase();

        return courseCode.includes(s) || courseName.includes(s);
      });

      return filtered;
    }
  } catch (err) {
    return [];
  }
};
/**
 * Get a single course by exact name (case-insensitive) using searchCourse
 * @param {string} name - exact course name
 * @returns {Object|null} - first matching course or null if not found
 */
export const getFirstCourseByName = async (name) => {
  if (!name || !name.trim()) return null;

  const allMatches = await searchCourse(name.trim());

  if (!allMatches || allMatches.length === 0) return null;

  const lowerName = name.trim().toLowerCase();

  // Find exact match ignoring case
  const exactMatch = allMatches.find(
    (course) => (course.courseName || "").toLowerCase() === lowerName
  );

  return exactMatch || null;
};